export default "__VITE_ASSET__b3d974d9__"